module.exports = __webpack_public_path__ + "static/img_1767-0b6bb26e3ac50f23f3290424e3475b0f.webp";